module.exports = "<ol class=\"breadcrumb\">\n  <li class=\"breadcrumb-item\" *ngFor=\"let breadcrumb of breadcrumbs; let last = last;\">\n    <a *ngIf=\"!last; else lastItem\" [routerLink]=\"[breadcrumb.url]\">{{ breadcrumb.label }}</a>\n    <ng-template #lastItem>{{ breadcrumb.label }}</ng-template>\n  </li>\n</ol>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/system/core/breadcrumb/breadcrumb.component.html
// module id = ./src/app/system/core/breadcrumb/breadcrumb.component.html
// module chunks = main